import { useRewardsContext } from 'src/lib/contexts/RewardsConfigContext'
import CustomisationTab from './CustomisationTab'
import UIPreview from 'src/components/common/ui-preview/UIPreview'
import { RewardsPageType } from 'src/lib/types/uiPreview'

const RewardsCustomisationTab = () => {
  const creditName = useRewardsContext(context => context.state?.creditName)
  const earnMessage = useRewardsContext(context => context.state?.earnMessage)
  const earnTileCustomiseUi = useRewardsContext(context => context.state?.earnTileCustomiseUi)

  const config: RewardsPageType = {
    creditName: creditName?.pluralName,
    earnMessage: {
      line_1: earnMessage?.line_1,
      line_2: earnMessage?.line_2
    },
    earnTileCustomiseUi: earnTileCustomiseUi
  }
  return (
    <>
      <div className='flex flex-row justify-between gap-6 p-0 w-full'>
        <CustomisationTab />
        <div className=''>
          <UIPreview pageType={'REWARDS'} config={config} />
        </div>
      </div>
    </>
  )
}

export default RewardsCustomisationTab
